import React from 'react';
import { Button } from './ui/Button';
export function Header() {
  return <header className="sticky top-0 z-40 w-full bg-cream-100/95 backdrop-blur-sm shadow-sm border-b border-cream-200" data-id="element-43">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-44">
        <div className="flex justify-between items-center h-16" data-id="element-45">
          <div className="flex-shrink-0 flex items-center" data-id="element-46">
            <span className="font-serif font-bold text-xl md:text-2xl text-coral-600 tracking-tight" data-id="element-47">
              Protocolo Cortisol <span className="text-dark-900" data-id="element-48">OFF</span>
            </span>
          </div>
          <div data-id="element-49">
            <Button variant="primary" className="px-4 py-2 text-sm md:text-base" data-id="element-50">
              QUIERO EL PROTOCOLO →
            </Button>
          </div>
        </div>
      </div>
    </header>;
}